import * as t from './actionTypes';

// reducer initial state
const initialState = { isLoading: false, season: [] };

// season reducer
const seasonReducer = (state = initialState, action) => {

  switch (action.type) {
    // set loading to true
    case t.SET_BUSY:
      return Object.assign({}, state, { isLoading: true });

    // set loading to false
    case t.UNSET_BUSY:
      return Object.assign({}, state, { isLoading: false });

    // set redux state to database Season
    case t.SEASON_LOAD_SUCCESS:
      let { season } = action;
      if (season) {
        return ({
          ...state,
          season: Object.keys(season).map(id => ({...season[id], id, }))
        })
      }
      else {
        return ({
          ...state,
          season: false
        })
      }

      // create new season
    case t.SEASON_CREATE_SUCCESS:
      let n = action.season;
      season = state.season;
      if (!season) season = [];
      season.push(n);

      state = Object.assign({}, state, { season: season });

      return state;

    // edit existing season
    case t.SEASON_EDIT_SUCCESS:
      let a = action.season;

      var curSeason = state.season;
      for (var i = 0; i < curSeason.length; i ++) {
        if (curSeason[i].id === action.id) {
          curSeason[i] = a;
          break;
        }
      }

      state = Object.assign({}, state, { season: curSeason });

      return state;

    case t.SEASON_DELETE_SUCCESS:
      curSeason = state.season;

      for (i = 0; i < curSeason.length; i ++) {
        if (curSeason[i].id === action.id) {
          curSeason.splice(i, 1);
          break;
        }
      }

      state = Object.assign({}, state, { season: curSeason });

      return state;

    default:
      return state;
  }
};

export default seasonReducer;
